export const TOOLTIP_STYLES = {
  default: 'default',
  square: 'square',
};
